import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "tooltip",
  class: "hidden absolute left-20 invisible group-hover:visible z-10 justify-center items-center px-6 h-10 text-white whitespace-nowrap bg-zinc-900 rounded shadow transition-opacity duration-300 lg:flex tooltip"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block overflow-hidden absolute inset-y-0 top-2 right-full w-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-10 bg-zinc-900 -rotate-45 origin-top-right" })
], -1)


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
  title: string | number | null
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(__props.title), 1)
  ]))
}
}

})